import React from 'react';
import { withRouter } from 'react-router-dom';

class VisualizarProduto extends React.Component {

    constructor() {

        super();

        this.state = {
            centro: "",
            centroId: 0,
            estoqueId: "",
            produto: "",
            embalagem: "",
            unidadeMedida: "",
            qtddEmbalagem: "",
            unidadesDisponiveis: "",
            ativo: ""
        };

        this.editar = this.editar.bind(this);
        this.abastecer = this.abastecer.bind(this);
        this.baixa = this.baixa.bind(this);
        this.fluxo = this.fluxo.bind(this);
        this.voltar = this.voltar.bind(this);

    }

    desformatarValor(s) {
        if (s === null) return ""; 
        return s.replace(",", ".");
    }   

    formatarValor(s) {
        if (s === null) return ""; 
        return s.replace(".", ",");
    }

    decimalMask(str_val) {

        let res = "";
        let vec = str_val.split(",");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }

            c++;

        }

        if (vec[1] !== undefined) res = res + "," + vec[1];
        else res = res + ",0";

        return res;

    }

    estaAtivo(ativo) {
        if (ativo)  return "Ativo";
        else return "Inativo";
    }

    editar() {

        let obj = {
            id: this.state.estoqueId,
            produto: this.state.produto,
            embalagem: this.state.embalagem,
            unidadeMedida: this.state.unidadeMedida,
            qtddEmbalagem: this.state.qtddEmbalagem,
            unidadesDisponiveis: this.state.unidadesDisponiveis,
            ativo: this.state.ativo,
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/editarestoque",
            state: obj
        });

    }

    abastecer() {

        if (this.state.ativo) {

            let obj = {
                id: this.state.estoqueId,
                produto: this.state.produto,
                embalagem: this.state.embalagem,
                unidadeMedida: this.state.unidadeMedida,
                qtddEmbalagem: this.state.qtddEmbalagem,
                unidadesDisponiveis: this.state.unidadesDisponiveis,
                ativo: this.state.ativo,
                centroId: this.state.centroId,
                centro: this.state.centro
            };

            this.props.history.push({
                pathname: "/abastecerestoque",
                state: obj
            });

        } else {

            this.props.errMsgHandler("Não é possível abastecer este produto pois ele está inativo.");

        }

    }

    baixa() {

        if (this.state.ativo) {

            let obj = {
                id: this.state.estoqueId,
                produto: this.state.produto,
                embalagem: this.state.embalagem,
                unidadeMedida: this.state.unidadeMedida,
                qtddEmbalagem: this.state.qtddEmbalagem,
                unidadesDisponiveis: this.state.unidadesDisponiveis,
                ativo: this.state.ativo,
                centroId: this.state.centroId,
                centro: this.state.centro
            };

            this.props.history.push({
                pathname: "/baixaestoque",
                state: obj
            });

        } else {

            this.props.errMsgHandler("Não é possível efetuar a baixa deste produto pois ele está inativo.");

        }

    }

    fluxo() {

        let obj = {
            id: this.state.estoqueId,
            produto: this.state.produto,
            embalagem: this.state.embalagem,
            unidadeMedida: this.state.unidadeMedida,
            qtddEmbalagem: this.state.qtddEmbalagem,
            unidadesDisponiveis: this.state.unidadesDisponiveis,
            ativo: this.state.ativo,
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/fluxoproduto",
            state: obj
        });

    }

    voltar() {

        let obj = {
            row: {
                id: this.state.centroId,
                data: [ this.state.centro ]
            }
        };

        this.props.history.push({
            pathname: "/estoquecentro",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleEstoque === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/estoque";
        }

        let estoqueId = this.props.location.state.row.id;
        this.setState({ estoqueId: estoqueId });

        fetch("/api/estoque/" + estoqueId, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ produto: responseJson.produto });
            this.setState({ embalagem: responseJson.embalagem });
            this.setState({ unidadeMedida: responseJson.unidade_medida });
            this.setState({ qtddEmbalagem: responseJson.qtdd_embalagem });
            this.setState({ unidadesDisponiveis: responseJson.unidades_disponiveis });
            this.setState({ ativo: responseJson.ativo });
            this.setState({ centro: responseJson.centro });
            this.setState({ centroId: responseJson.centro_id });

        });

    }

    render() {
        return(
            <div>
                <h1 id="visualizar-produto-title">Produto</h1><br /><br />
                <p id="visualizar-produto-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br />
                <table id="visualizar-produto-table">
                    <tbody>
                        <tr>
                            <td><b>Produto:</b></td>
                            <td>{ this.state.produto }</td>
                        </tr>
                        <tr>
                            <td><b>Embalagem:</b></td>
                            <td>{ this.state.embalagem }</td>
                        </tr>
                        <tr>
                            <td><b>Unidade de medida:</b></td>
                            <td>{ this.state.unidadeMedida }</td>
                        </tr>
                        <tr>
                            <td><b>Quantidade na embalagem:</b></td>
                            <td>{ this.decimalMask(this.state.qtddEmbalagem) }</td>
                        </tr>
                        <tr>
                            <td><b>Unidades disponíveis:</b></td>
                            <td>{ this.state.unidadesDisponiveis + " ("
                                    + this.decimalMask(this.formatarValor(parseFloat(
                                        this.desformatarValor(this.state.qtddEmbalagem) * this.state.unidadesDisponiveis).toString()))
                                    + " " + this.state.unidadeMedida + ")" }</td>
                        </tr>
                        <tr>
                            <td><b>Status:</b></td>
                            <td>{ this.estaAtivo(this.state.ativo) }</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <br />
                <button Class="visualizar-estoque-btn"
                    id="visualizar-estoque-voltar-btn"
                    onClick={ this.voltar }>Voltar</button>
                { localStorage.roleEstoque === "escrever" &&
                    <button Class="visualizar-estoque-btn"
                        id="visualizar-estoque-editar-btn"
                        onClick={ this.editar }>Editar</button> }
                { localStorage.roleEstoque === "escrever" &&
                    <button Class="visualizar-estoque-btn"
                        id="visualizar-estoque-abastecer-btn"
                        onClick={ this.abastecer }>Abastecer</button> }
                { (localStorage.roleEstoque === "escrever" || localStorage.roleEstoque === "baixa") &&
                    <button Class="visualizar-estoque-btn"
                        id="visualizar-estoque-baixa-btn"
                        onClick={ this.baixa }>Baixa</button> }
                <button Class="visualizar-estoque-btn"
                    id="visualizar-estoque-fluxo-btn"
                    onClick={ this.fluxo }>Fluxo</button>
                <br /><br />
            </div>
        );
    }

}

export default withRouter(VisualizarProduto);

